import { createContext, useContext } from 'react';

export const LineClientsContext = createContext();

export const useLineClients = () => {
  return useContext(LineClientsContext);
};
